(function($){
	/* Login form */
	$('#login-form').on('submit', function(e) {
		e.preventDefault();
		var $this = $(this);

		var $loginButton = $this.find('.login-btn').first();
		var backupLabel = $loginButton.html();

		$this.ajaxSubmit({
			type: $this.attr('method'),
			url: $this.attr('action'),
			dataType: 'json',
			beforeSubmit: function() {
				$this.find('.tooltip').remove();
				$loginButton.prop('disabled', true);
				$loginButton.html($loginButton.data('loading-text'));
			},
			error: function(jqXHR, status, error) {
				$loginButton.prop('disabled', false);
				$loginButton.html(backupLabel);
				toastr.error('Login derzeit nicht möglich.', '', notificationOptions);
			},
			success: function(callback, status, jqXHR) {
				$loginButton.prop('disabled', false);
				$loginButton.html(backupLabel);

				if (null !== callback) {
					if (jqXHR.status === 200 && callback.redirect) {
						window.location.replace(callback.redirect);
					} else if (jqXHR.status === 200 && typeof callback === 'object') {
						toastr.error(callback.message, '', notificationOptions);
					}
				}
			}
		});
	});

	// Reset password form
	$('#resetpassword__form').on('submit', function(e) {
		e.preventDefault();
		var $this = $(this);

		var $resetPasswordButton = $this.find('.resetpassword__button').first();
		var backupLabel = $resetPasswordButton.html();

		$this.ajaxSubmit({
			type: $this.attr('method'),
			url: $this.attr('action'),
			dataType: 'json',
			beforeSubmit: function() {
				$this.find('.tooltip').remove();
				$resetPasswordButton.prop('disabled', true);
				$resetPasswordButton.html($resetPasswordButton.data('loading-text'));
			},
			error: function(jqXHR, status, error) {
				$resetPasswordButton.prop('disabled', false);
				$resetPasswordButton.html(backupLabel);
				toastr.error('Dienst momentan nicht verfügbar.', '', notificationOptions);
			},
			success: function(callback, status, jqXHR) {
				$resetPasswordButton.prop('disabled', false);
				$resetPasswordButton.html(backupLabel);

				if (null !== callback) {
					if (jqXHR.status === 200 && callback.type == "Success") {
						toastr.success(callback.message, '', notificationOptions);
					} else if (jqXHR.status === 200 && callback.type == "Error") {
						toastr.error(callback.message, '', notificationOptions);
					}
				}
			}
		});
	});
 })(jQuery);
